import { Flex, Text, Image, Box, Button, useToast } from "@chakra-ui/react";

import avatar from "../../images/Avatar.png";
import Insta from "../../images/insta_logo.png";
import Facebook from "../../images/facebook_logo.png";
import Youtube from "../../images/youtube_logo.png";
import tiktok from "../../images/tictok_logo.png";
import ProgressLike from "../ResultLists/ProgressLike";
import { createSettlement } from "../../api";

const BRAND = {
  blue: "#0054C0",
  textPrimary: "#172940",
  textSecondary: "#5D6979",
  cardBg: "white",
};

const PLATFORM_ICONS = {
  instagram: Insta,
  youtube: Youtube,
  tiktok: tiktok,
  facebook: Facebook,
};

export default function CreatorInfo({ data, campaign }) {
  const toast = useToast();

  const handleSettlement = async () => {
    try {
      const id = data.livePostRecordId;
      await createSettlement({ id });

      toast({
        title: "정산서 요청 완료",
        description: "정산서 발행 요청이 성공적으로 처리되었습니다.",
        status: "success",
        duration: 2000,
        isClosable: true,
      });
    } catch (err) {
      console.error("Settlement error:", err);
      toast({
        title: "오류 발생",
        description:
          err?.response?.data?.message ??
          "정산서 발행 요청 중 오류가 발생했습니다.",
        status: "error",
        duration: 2000,
        isClosable: true,
      });
    }
  };
  return (
    <Flex
      w="100%"
      position="relative"
      align="stretch"
      bg={BRAND.cardBg}
      px="12px"
      py="25px"
      gap="12px"
      flexDir="column"
      borderRadius="16px"
      boxShadow="0px 4px 12px rgba(23, 41, 64, 0.20)"
    >
      {data.settlementStatus === "DRAFT" && (
        <Box
          position="absolute"
          top="-0.1px"
          left="0.1px"
          bg="#A2A9B3"
          color="white"
          px="10px"
          py="3px"
          fontSize="12px"
          borderRadius="8px"
          fontWeight="700"
          zIndex={10}
          boxShadow="0 2px 6px rgba(0,0,0,0.12)"
        >
          정산서 발행 대기
        </Box>
      )}

      <Flex w={{ base: "100%", md: "100%" }} flexDir="column" gap="20px">
        <Flex gap="12px" flexDir="column">
          <Flex
            w="100%"
            flexDir="column"
            p="8px"
            border="1px solid #D1D4D9"
            borderRadius="8px"
            gap="2px"
          >
            <Text color={BRAND.textSecondary} fontSize="12px" fontWeight={500}>
              크리에이터
            </Text>
            <Flex gap="12px" align="center">
              <Image src={data.creator.avatarUrl ?? avatar} w="40px" h="40px" />
              <Text fontSize="20px" fontWeight={700}>
                {data.creator.username}
              </Text>
              <Image
                w="24px"
                h="24px"
                src={
                  PLATFORM_ICONS[data.creator.channelPlatform?.toLowerCase()] ??
                  "/images/default.png"
                }
                alt="platform-icon"
              />
            </Flex>
          </Flex>
          <Flex gap="8px">
            <Flex
              w="100%"
              flexDir="column"
              p="8px"
              gap="2px"
              border="1px solid #D1D4D9"
              borderRadius="8px"
            >
              <Text color="#5D6979" fontSize="12px" fontWeight={500}>
                목표 KPI
              </Text>
              <Text fontSize="16px" fontWeight={600}>
                {data.insight.billingModel === "CPUC"
                  ? data.insight.actualInteractions
                  : data.insight.actualReach}
                회{" "}
                {data.insight.billingModel === "CPUC"
                  ? "고유 클릭"
                  : "고유 노출"}
              </Text>
            </Flex>
            <Flex
              w="100%"
              flexDir="column"
              p="8px"
              gap="2px"
              border="1px solid #D1D4D9"
              borderRadius="8px"
            >
              <Text color="#5D6979" fontSize="12px" fontWeight={500}>
                KPI 단가
              </Text>
              <Text fontSize="16px" fontWeight={600}>
                {data.insight?.unitPrice}
                {data.currency}
              </Text>
            </Flex>
          </Flex>
        </Flex>

        {/* ========== 목표 달성률 Card ========== */}
        <Flex
          flexDir="column"
          gap="6px"
          border="1px solid #D1D4D9"
          borderRadius="8px"
          p="12px"
        >
          <Flex justify="space-between">
            <Text color="#5D6979" fontSize="12px" fontWeight={500}>
              목표 달성률
            </Text>
            <Flex align="center">
              <Text color="#0054C0" fontSize="14px" fontWeight={700}>
                {data.insight.billingModel === "CPUC"
                  ? data.insight.actualInteractions
                  : data.insight.actualReach}
              </Text>
              <Text color="#5D6979" fontSize="12px" fontWeight={500}>
                /{data.insight.targetValue}
              </Text>
            </Flex>
          </Flex>
          <ProgressLike percent={data.insight.goalAchievementRate * 100} />
          <Flex justify="space-between" align="center">
            <Text color="#5D6979" fontSize="12px" fontWeight={500}>
              정산 비용
            </Text>
            <Text color="#0054C0" fontSize="16px" fontWeight={700}>
              {data.grossAmount?.toLocaleString()}
              {data.currency}
            </Text>
          </Flex>
        </Flex>
        {data.settlementStatus === "DRAFT" && (
          <Button bg="#0054C0" color="white" onClick={handleSettlement}>
            정산서 발행
          </Button>
        )}
      </Flex>
    </Flex>
  );
}
